import { Component, OnInit, AfterViewInit } from '@angular/core';

@Component({
    selector: 'app-scrollable',
    templateUrl: './scrollable.component.html',
    standalone: false,
})
export class ScrollableComponent implements OnInit, AfterViewInit {
    public psDisabled: boolean = true;

    public constructor() {}

    public ngOnInit(): void {}

    public ngAfterViewInit(): void {
        setTimeout(() => {
            this.psDisabled = false;
        }, 300);

    }
}
